/**
 * Pulls a human-readable message out of whatever `ReparoApi` threw.
 *
 * It rejects with the `ApiError` shape (`{ status, error: { message, ... } }`), but
 * plain `Error`s reach callers too — from a thrown validator, say. Checking both
 * keeps a real backend message (a 409's "already exists in your catalog") from
 * being swallowed by a generic fallback.
 */
export const readApiError = (err: unknown, fallback: string): string => {
    const candidate = err as { error?: { message?: string }; message?: string };
    return candidate?.error?.message ?? candidate?.message ?? fallback;
};
